module.exports = __webpack_public_path__ + "img/62a4a1d.png";